import { Heading } from "@/components/ui/heading";
import { VStack } from "@/components/ui/vstack";
import type { ReactNode } from "react";

export interface PageTitleProps {
  children?: ReactNode;
  className?: string;
  title: string;
}

const PageTitle = ({ children, className, title }: PageTitleProps) => {
  return (
    <VStack className={`gap-[8px] ${className}`}>
      {children}
      <Heading className="flex-1 font-[700] leading-[24.2px] text-[20px] text-center text-typography-900">{title}</Heading>
    </VStack>
  );
};

export default PageTitle;
